<div class="box-navbar">
    <div class="menu">
        <span class="material-symbols-outlined pointer" *ngIf="statusMenu" (click)="changeStatusMenu()">
            menu
        </span>
        <span class="material-symbols-outlined pointer" *ngIf="!statusMenu" (click)="changeStatusMenu()">
            sort
        </span>
    </div>
    <div class="logo"><img src="assets/logo/navbar.svg" alt=""></div>
    <span class="material-symbols-outlined me-4">
        notifications
    </span>
    <div class="profile me-2">
        <div class="box-person pointer" (click)="viewMenu(menu,$event)">
            <span class="material-symbols-outlined">
                person
            </span>
        </div>
    </div>
</div>
<p-menu [model]="setitem" #menu [popup]="true"></p-menu>

<!-- <app-nb-contact [view]="profile" (update)="closeProfile()"></app-nb-contact> -->